var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessThanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_feedback_hands)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1729 0.80961C14.3188 0.265744 14.8732 -0.0580477 15.4111 0.0859776C15.9491 0.230135 16.2677 0.787996 16.1221 1.33207L14.5117 7.34184C14.4729 7.48683 14.5569 7.63626 14.7002 7.67484C14.8437 7.71329 14.9924 7.62658 15.0312 7.48149L16.3154 2.68656C16.4612 2.14251 17.0157 1.81793 17.5537 1.96195C18.0918 2.10613 18.4095 2.66489 18.2637 3.20902L16.3184 10.4707C16.2733 10.6387 16.4776 10.758 16.5996 10.6348L17.7695 9.45219C18.2737 8.94307 19.0894 8.94103 19.5908 9.44731C20.0919 9.95348 20.0897 10.7761 19.5859 11.2852L17.0039 13.8887C16.8571 14.0204 16.7136 14.1501 16.5732 14.2784L16.5723 14.2803C16.3416 14.4912 16.1178 14.6952 15.8975 14.8907L13.1621 4.57914L14.1729 0.80961Z",
    fill: "url(#paint0_feedback_hands)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5293 0.805704C11.6751 0.261569 12.2295 -0.0630793 12.7676 0.0810948C13.3054 0.225328 13.623 0.783271 13.4775 1.32719L12.8184 3.78422C12.401 3.19804 11.6881 2.8698 10.9521 2.95902L11.5293 0.805704Z",
    fill: "url(#paint1_feedback_hands)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86474 2.47462C5.43446 2.32196 6.02145 2.66527 6.17583 3.24141L7.88093 9.60493C7.92209 9.75857 8.07862 9.85012 8.23055 9.80941C8.38247 9.7687 8.47226 9.61115 8.43109 9.45752L6.91234 3.78946C6.75796 3.21332 7.09466 2.62251 7.66437 2.46986C8.23409 2.3172 8.82108 2.66051 8.97546 3.23665L10.6899 9.63494C10.731 9.78858 10.8876 9.88013 11.0395 9.83942C11.1914 9.79871 11.2812 9.64117 11.24 9.48753L10.066 5.10609C9.91166 4.52995 10.2484 3.93914 10.8181 3.78648C11.3878 3.63383 11.9748 3.97713 12.1292 4.55328L14.6821 14.0812L14.6689 14.0847C15.1086 16.4274 13.6954 18.7434 11.3803 19.3638C8.17035 20.2239 6.2146 20.7471 10.345 19.6412C6.88533 20.5682 5.50404 19.2119 3.63521 17.5035L3.63403 17.5025C3.48544 17.3666 3.33426 17.2284 3.17883 17.0889L0.444969 14.3331C-0.0888966 13.7941 -0.0913376 12.9225 0.439527 12.3865C0.970393 11.8504 1.83352 11.8528 2.36739 12.3919L3.6071 13.6437C3.73633 13.7742 3.95229 13.6487 3.90463 13.4708L1.84417 5.78106C1.6898 5.20492 2.02649 4.61411 2.59621 4.46146C3.16592 4.3088 3.75291 4.65211 3.90729 5.22825L5.26764 10.3052C5.30881 10.4588 5.46534 10.5503 5.61727 10.5096C5.76919 10.4689 5.85898 10.3114 5.81781 10.1577L4.11271 3.79422C3.95833 3.21808 4.29503 2.62727 4.86474 2.47462Z",
    fill: "url(#paint2_feedback_hands)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 1C9.99992 1.27614 9.77607 1.5 9.49992 1.5C9.22378 1.5 8.99992 1.27614 8.99992 1V0.5C8.99992 0.223858 9.22378 0 9.49992 0C9.77607 0 9.99992 0.223858 9.99992 0.5V1Z",
    fill: "#AC9FDF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41414 1C7.6094 1.19526 7.6094 1.51184 7.41414 1.70711C7.21888 1.90237 6.90229 1.90237 6.70703 1.70711L6.35348 1.35355C6.15822 1.15829 6.15822 0.841709 6.35348 0.646447C6.54874 0.451184 6.86532 0.451184 7.06058 0.646447L7.41414 1Z",
    fill: "#AC9FDF",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_feedback_hands",
    x1: 19.1122,
    y1: 0.834866,
    x2: 5.89775,
    y2: 22.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_feedback_hands",
    x1: 19.1122,
    y1: 0.834866,
    x2: 5.89775,
    y2: 22.2865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_feedback_hands",
    x1: 0.906832,
    y1: 3.90589,
    x2: 13.2558,
    y2: 14.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBAAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A171FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_feedback_hands"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessThanks);
export default __webpack_public_path__ + "static/media/success-thanks.c8c65ba30821cee7ac5dcce7d86e590e.svg";
export { ForwardRef as ReactComponent };